import * as React from "react";
import { Route, Switch } from "react-router-dom";
import App from "./App";
import "./form.scss";
import "./index.scss";
import Login from "./login/Login";
import LoginWithSSO from "./login/LoginWithSSO";
import ResetPassword from "./login/ResetPassword";
import RedirectComponent from "./redirectComponent/RedirectComponent";
import AlertBanner from "./shared/alertBanner/AlertBanner";

export const Root: React.SFC = () => (
  <React.Fragment>
    <AlertBanner />
    <Switch>
      <Route path="/login" component={Login} />
      <Route exact={true} path="/resetPassword" component={ResetPassword} />
      <Route exact={false} path="/redirect_url" component={RedirectComponent} />
      <Route exact={true} path="/login_sso" component={LoginWithSSO} />
      <Route component={App} />
    </Switch>
  </React.Fragment>
);

export default Root;



// WEBPACK FOOTER //
// ./src/Root.tsx